// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2755 ? "7ef09c20" : chunkId) + "." + {"627":"cbe5ff327957e105","2755":"fe5be542edfa8ff7"}[chunkId] + ".js";
};